export type WorkspaceThemeMode = 'light' | 'dark';

export interface WorkspaceThemeClasses {
  shell: string;
  surface: string;
  surfaceAlt: string;
  border: string;
  text: string;
  muted: string;
  faint: string;
  accentBtn: string;
  accentSoft: string;
  selectedRow: string;
  selectedBar: string;
  input: string;
  bubbleIn: string;
  bubbleOut: string;
  bubbleBot: string;
  badge: string;
  topbarSearch: string;
}

const light: WorkspaceThemeClasses = {
  shell: 'bg-gray-50 text-gray-900',
  surface: 'bg-white',
  surfaceAlt: 'bg-gray-50',
  border: 'border-gray-200',
  text: 'text-gray-900',
  muted: 'text-gray-500',
  faint: 'text-gray-400',
  accentBtn: 'bg-blue-600 hover:bg-blue-700 text-white',
  accentSoft: 'bg-blue-50 text-blue-700',
  selectedRow: 'bg-blue-50',
  selectedBar: 'bg-blue-600',
  input: 'bg-gray-50 border-gray-300 text-gray-900 placeholder:text-gray-400 focus:border-blue-500 focus:ring-blue-500',
  bubbleIn: 'bg-gray-100 text-gray-800',
  bubbleOut: 'bg-blue-600 text-white',
  bubbleBot: 'bg-purple-100 text-purple-900',
  badge: 'bg-gray-100 text-gray-600',
  topbarSearch: 'bg-gray-50 border-gray-200 text-gray-500',
};

const dark: WorkspaceThemeClasses = {
  shell: 'bg-gray-950 text-gray-100',
  surface: 'bg-gray-900',
  surfaceAlt: 'bg-gray-900/80',
  border: 'border-gray-800',
  text: 'text-gray-100',
  muted: 'text-gray-400',
  faint: 'text-gray-500',
  accentBtn: 'bg-blue-600 hover:bg-blue-500 text-white',
  accentSoft: 'bg-blue-950/70 text-blue-300',
  selectedRow: 'bg-blue-950/50',
  selectedBar: 'bg-blue-400',
  input: 'bg-gray-900 border-gray-700 text-gray-100 placeholder:text-gray-500 focus:border-blue-500 focus:ring-blue-500',
  bubbleIn: 'bg-gray-800 text-gray-200',
  bubbleOut: 'bg-blue-700 text-blue-50',
  bubbleBot: 'bg-purple-950/70 text-purple-200',
  badge: 'bg-gray-800 text-gray-300',
  topbarSearch: 'bg-gray-900 border-gray-800 text-gray-400',
};

export const getWorkspaceTheme = (mode: WorkspaceThemeMode): WorkspaceThemeClasses => {
  if (mode === 'dark')
  {
    return dark;
  }

  return light;
};
